import { Wrapper } from '../components/common'

const Error = () => {
  return <Wrapper>Something went wrong!</Wrapper>
}

export default Error
